<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <!-- Titolo toolbar -->
      <v-toolbar-title class="white--text"> Elimina avviso </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <!-- Messaggio di conferma -->
      <v-row class="pt-5 ml-5 mr-5" justify="center" align="center">
        <v-col> <h1 style="font-weight:normal;">Sei sicuro di voler eliminare "{{this.selez.des}}"?</h1> </v-col>
      </v-row>

      <!-- Pulsanti "Conferma" e "Annulla" -->
      <v-row class="pt-5 ml-5 mr-5" justify="center">
        <v-col align="right"> <v-btn  @click="$emit('click_conferma_eliminazione');"> Conferma </v-btn> </v-col>
        <v-col align="left"> <v-btn @click="$emit('click_chiudi_eliminazione');"> Annulla </v-btn> </v-col>
      </v-row>
    </v-card-text>

  </v-card>
</template>

<script>

export default {
  name: "ConfermaEliminazioneNotifiche",
  props:["selez"]
}
</script>

